<script lang="ts">


    import { Character, characterStore } from "../character/character";
import { translate } from "../translation";

    type KeyValue = {
        subkey: string;
        value: number;
    } 


    export let title;
    export let key: string;

    let keyValues: KeyValue[] = [];
    let character: Character;


    characterStore.subscribe((chara) => {
        keyValues = Object.keys(chara[key])
            .map(subkey => {
                return {
                    subkey,
                    value: parseInt(chara[key][subkey])
                }
            });

        console.log("Tile.subscribe",keyValues)
        character = chara;
    });
</script>

<main>
    <div
        class="
		    border border-gray-300 rounded-md 
			bg-gray-100
			p-2 
		"
    >
        <h3>{title}</h3>
        {#each keyValues as {subkey, value}, i }
            <label for={subkey}>
                {translate(key + "." + subkey)}
            </label>
            {#if "number" == typeof character[key][subkey]}
                <input
                    type=number
                    bind:value={value}
                    on:change={() => {
                        character[key][subkey] = value;
                        characterStore.set(character);
                    }}

                />

            {:else}
                <input
                    type="string"
                    bind:value={character[key][subkey]}
                    on:input={() => characterStore.set(character)}
                />
            {/if}
        {/each}
    </div>
</main>
